import styled from "styled-components";

export const Expired = styled.div`
  text-align: center;
  padding: 2rem;
  border: 1px solid #ebebeb;
  border-radius: 0.25rem;
  margin: 0.5rem;
`;
export const ExpiredMessage = styled.span`
  font-size: 3rem;
  font-weight: bold;
  color: red;
`;
export const ExpiredNote = styled.p`
  font-size: 1.5rem;
`;

export const Counter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.75rem;
  padding: 5rem;
  border: 3px solid #ebebeb;
  border-radius: 0.25rem;
  color: #000;
  margin-top: 20px;
`;

export const Timer = styled.div`
  padding: 5px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
